module.exports = __webpack_public_path__ + "img/event_mobile_xs_6_fr.d21e98f9.png";